// Node Modules
import { RichText } from 'prismic-reactjs';
import { nanoid } from 'nanoid';

// Components
import StyledCard from '@/components/global-components/styled-card/StyledCard';
import InformationCard from '@/components/global-components/information-card/InformationCard';
import Button from '@/components/global-components/Button';

// Themes
import theme from '@/themes/index';

const GroupTours = ({
  cpiGroups,
  whyCpiGroups,
  isDesktop,
}) => {
  const getGroupToursContent = () => {
    return (
      <>
        <div className='group-container'>
          <div className='header'>
            <h4>{cpiGroups.cardContent.title}</h4>
            <h6>{cpiGroups.cardContent.subTitle}</h6>
          </div>
          <div className='description-container'>
            <RichText render={cpiGroups.cardContent.description} />
          </div>
        </div>
        <style jsx>{`
          div.group-container {
            display: flex;
            flex-direction: column;
          }

          div.group-container .header {
            align-items: center;
            display: flex;
            flex-direction: column;
            text-align: center;
            gap: 1rem;
            padding-bottom: 1rem;
          }

          div.group-container .header h4 {
            max-width: 36.625rem;
            font-family: ${theme.fontFamilies.montserratBold}
          }

          div.group-container .header h6 {
            max-width: 54.563rem;
          }

          @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {

            div.group-container .header h6 {
              line-height: 2rem;
            }
          }

          @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
            div.group-container .header {
              gap: 2rem;
            }

            div.group-container .header h6 {
              line-height: 2.25rem;
            }
          }
        `}</style>
      </>
    );
  }

  const getCpiGroupsContent = () => {
    return (
      <>
        <div className='explanation-container'>
          <InformationCard content={whyCpiGroups} showTitle={true} />
          <div className='buttons-container'>
            {whyCpiGroups.cardContent.buttons.map(item => (
              <Button
                key={nanoid()}
                className={item.button.style.toLowerCase()}
                text={item.button.title}
                href={item.button.url}
                target={item.button.openInAnotherPage ? '_blank' : '_self'}
                styles={{
                  width: isDesktop ? 'fit-content' : '100%',
                  padding: '0 1rem',
                }}
              />
            ))}
          </div>
        </div>
        <style jsx>{`
          div.explanation-container {
            display: flex;
            flex-direction: column;
          }
          
          div.explanation-container .buttons-container {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            padding-top: 1rem;
            align-items: center;
          }

          @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
            div.explanation-container .buttons-container {
              flex-direction: row;
              justify-content: center;
            }
          }

          @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
            div.explanation-container .buttons-container {
              gap: 2rem;
              padding-top: 1rem;
              justify-content: left;
            }
          }
        `}</style>
        <style global jsx>{`
          div.explanation-container .card-content h4 {
            font-family: ${theme.fontFamilies.montserrat} !important;
            font-size: 1.5rem;
            line-height: 1.875rem;
            margin-block-start: 1rem;
            margin-block-end: 1rem;
          }

          div.explanation-container .card-content ul {
            font-family: ${theme.fontFamilies.openSans};
            font-size: 1rem;
            line-height: 1.875rem;
            padding-inline-start: 1.275rem;
            text-align: left;
          }

          div.explanation-container .buttons-container a {
            text-align: center;
          }

          @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
            div.explanation-container .card-content h4 {
              font-size: 2rem;
              line-height: 3rem;
              margin-block-start: 1.33rem;
              margin-block-end: 1.33rem;
            }

            div.explanation-container .card-content ul {
              font-size: 1.25rem;
            }
          }
        `}</style>
      </>
    );
  }

  return (
    <>
      <div className='container'>
        <div className='group-tours-container'>
          <StyledCard
            content={cpiGroups}
            containerStyle={{
              flexDirection: 'column-reverse', 
            }}
            infoContainerStyle={{
              padding: isDesktop ? '3rem 0 0' : '1rem 0 0',
            }}
          >
            {getGroupToursContent()}
          </StyledCard>
        </div>
        <div className='cpi-groups-container'>
          <StyledCard
            content={whyCpiGroups}
            infoContainerStyle={{
              paddingRight: isDesktop ? '0.5rem' : '0',
            }}
            imageStyles={{
              maxWidth: isDesktop ? '581px' : '100%',
              maxHeight: isDesktop ? '400px' : '100%',
            }}
          >
            {getCpiGroupsContent()}
          </StyledCard>
        </div>
      </div>
      <style jsx>{`
        div.container {
          display: flex;
          flex-direction: column;
          gap: 3.875rem;
        }
      `}</style>
    </>
  )
};

export default GroupTours;